<template>
    <div class="car-order-wrapper" v-show="token">
        <div class="car-order-center">
            <div class="cell-group hotel-preview">
                <div class="each-cell">
                    <div class="right-flex">
                        <div class="title" v-text="data.lineName"></div>
                    </div>
                </div>
                <div class="each-cell">
                    <span class="grey">套餐：</span>
                    <span class="black">{{ data.name }}</span>
                </div>
                <div class="each-cell">
                    <div class="label">
                        <div class="grey">使用日期</div>
                    </div>
                    <div class="content">
                        <span
                            @click.stop="showCalendar"
                            v-show="!selectedDate"
                            class="select-date"
                        >
                            请先选择日期
                            <img
                                :src="rightIconSrc"
                                alt="right-icon"
                                class="se-img"
                            />
                        </span>
                        <span
                            @click.stop="showCalendar"
                            v-show="selectedDate"
                            class="selected-date"
                        >
                            {{ selectedDate }}
                            <img
                                :src="rightIconSrc"
                                alt="right-icon"
                                class="se-img"
                            />
                        </span>
                    </div>
                </div>
            </div>
            <div class="cell-group hotel-preview">
                <div class="each-cell each-cell-specail-wrapper">
                    <div class="each-cell each-cell-specail">
                        <div class="label title">购买数量</div>
                        <div class="price-wra" v-if="price">
                            <span class="suffix">￥</span>
                            <span class="price">{{ price }}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="limit-wra">
                    <img :src="limitIconSrc">
                    限购{{ticketArr.stockNum}}张
        </div>-->
                <div class="each-cell">
                    <div class="right-flex">
                        <div class="type-intro" @click.stop="openModal">
                            预定须知
                            <img :src="rightIconSrc" alt="right-icon" />
                        </div>
                        <div class="content">
                            <van-stepper
                                v-model="countNumber"
                                :min="1"
                                @plus="plusItemNumber()"
                                async-change
                                integer
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="cell-group form">
                <div class="each-cell">
                    <div class="label title">联系人信息</div>
                </div>
                <label class="each-cell" for="username">
                    <div class="label">
                        <div class="title">姓名</div>
                    </div>
                    <div class="content">
                        <van-field
                            v-model="username"
                            autocomplete="off"
                            id="username"
                            placeholder="请填写订单联系人名称"
                        />
                    </div>
                </label>
                <label class="each-cell" for="tel">
                    <div class="label">
                        <div class="title">联系电话</div>
                    </div>
                    <div class="content">
                        <van-field
                            v-model="telNumber"
                            autocomplete="off"
                            type="number"
                            id="tel"
                            placeholder="请输入手机号"
                        />
                    </div>
                </label>
            </div>
        </div>
        <div class="submit-wrapper">
            <div class="total" v-cloak>
                <span class="price-wra">
                    <span class="suffix">￥</span>
                    <span class="price">{{ totalPrice }}</span>
                </span>
            </div>
            <div class="confirm-btn" @click.stop="submit">
                <img v-if="isCostLoading" :src="loadingSrc" class="loading" />
                <span v-else>确认提交</span>
            </div>
        </div>
        <order-intro-modal
            :intro-data="data"
            :fromOrder="1"
            ref="modal"
            :is-show-bottom="false"
        ></order-intro-modal>
        <select-date
            :prices="prices"
            @confirm="receiveDate"
            :islimit="isCurrentLimit"
            :saleprice="limitSalePrice"
            ref="selecteddate"
        ></select-date>
        <page-guide v-show="showPageGuide"></page-guide>
    </div>
</template>

<script>
import { _auth } from "@/js/auth";
import OrderIntroModal from "@/components/OrderIntroModal";
import SelectDate from "@/components/common/SelectDate.vue";
import PageGuide from "@/components/common/PageGuide";
export default {
    name: "RoomOrder",
    components: { OrderIntroModal, SelectDate, PageGuide },
    props: {
        // layoutType: String,
    },
    data() {
        return {
            selectedDate: "",
            username: "",
            telNumber: "",
            specsId: "",
            durationDay: sessionStorage.durationDay,
            carPriceData: {
                number: 1,
                datePrice: [],
            },
            switchs: false,
            isCostLoading: false,
            data: {},
            ticketArr: [],
            countNumber: "",
            isCurrentLimit: false,
            limitSalePrice: "",
            prices: {},
            rightIconSrc: "",
            limitIconSrc: "",
            loadingSrc: "",
            token: sessionStorage.getItem("token") || "",
            showPageGuide: true,
        };
    },
    computed: {
        totalPrice() {
            let stocks = this.data.stockData;
            let _selectedDate = this.selectedDate;
            if (!stocks) return 0;
            let currentDate = stocks.filter((el) => {
                return el.stockDate == _selectedDate;
            });
            if (!currentDate[0]) return 0;
            let totalPrice = currentDate[0].salePrice * this.countNumber;
            return UTILS.resolvePriceCeil2(totalPrice);
        },
        price() {
            let stocks = this.data.stockData;
            let _selectedDate = this.selectedDate;
            if (!stocks) return 0;
            let currentDate = stocks.filter((el) => {
                return el.stockDate == _selectedDate;
            });
            if (!currentDate[0]) return 0;
            let priceNumber = currentDate[0].salePrice;
            return UTILS.resolvePriceCeil2(priceNumber);
        },
        arriveDateFormat() {
            return moment(sessionStorage.arriveDateString).format("MM月DD日");
        },
        leaveDateFormat() {
            return moment(sessionStorage.leaveDateString).format("MM月DD日");
        },
    },
    watch: {
        telNumber(val) {
            var val = val || "";
            this.telNumber = val.slice(0, 11);
        },
    },
    created() {
        if (this.token) {
            this.getOrderList();
        } else {
            _auth(this, () => {
                this.getOrderList();
            });
        }
    },
    mounted() {
        this.rightIconSrc = API.ossUrl + "home/png/gray-right-arrow.png";
        this.limitIconSrc = API.ossUrl + "yyq/limit-icon.png";
        this.loadingSrc = API.ossUrl + "common/loading.svg";
    },
    destroyed() {},
    methods: {
        plusItemNumber() {
            if (!this.selectedDate) {
                this.$alert("请先选择日期！");
                this.$nextTick(() => {
                    this.countNumber--;
                });
            }
        },
        showCalendar() {
            this.$refs.selecteddate.openModal();
            this.showPageGuide = false;
        },
        updatePriceCalendar() {
            //主票为点进来的那个票种 价格日历显示主票的价格
            // "stockType" 库存类型，1：限量库存，2：日期库存
            let mainTicket = this.ticketArr;

            if (mainTicket instanceof Array && mainTicket.length == 0) {
                return;
            }
            if (mainTicket[0].stockType == 2) {
                let price = {};
                //日期库存中存在某天是无限库存的情况（stockNum === -1） 所以只能把stockNum===0的情况筛掉
                mainTicket
                    .filter((stock) => stock.stockNum !== 0)
                    .forEach((e) => {
                        price[e.stockDate] = `￥${e.salePrice}`;
                    });
                this.prices = price;
                this.isCurrentLimit = false;
            } else {
                this.isCurrentLimit = true;
                this.limitSalePrice = `￥${mainTicket.salePrice}`;
            }
        },
        /**
         * 根据ticketId获取下单需要的详细信息
         */
        getOrderList() {
            let vm = this;
            this.$axios
                .get(
                    `${window.API.route.routePackage}/${this.$route.params.ticketId}?token=${sessionStorage.token}`
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        vm.data = data.data;
                        let priceArr = vm.data.stockData.map((e) => {
                            return {
                                date: e.stockDate.split("-").slice(1).join("-"),
                                price: e.salePrice,
                            };
                        });
                        vm.ticketArr = data.data.stockData;
                        vm.specsId = data.data.specsId;
                        vm.updatePriceCalendar();
                        vm.$set(vm.carPriceData, "datePrice", priceArr);
                    } else {
                        vm.$toast(data.msg);
                    }
                })
                .catch((err) => console.log(err));
        },
        submit() {
            if (this.isCostLoading) return;
            if (this.validateInput()) {
                this.isCostLoading = true;
                this.postOrder(UTILS.callPayService);
            } else {
                //如果上一级页面数据项没有填写完成检验不通过，则返回上一级页面。
                if (window.location.href.includes("mdl")) {
                    this.$router.go(-1);
                }
            }
        },
        /**
         * 提交订单
         */
        postOrder(cb) {
            // let vm = this;
            let body = {
                id: this.specsId,
                count: this.countNumber,
                userName: this.username,
                phone: this.telNumber,
                totalPrice: this.totalPrice,
                useDate: this.selectedDate,
                payWay: window.ua == "wx" ? 1 : 2,
                promoteStr: localStorage.promoteStr || "",
                fromChannel: sessionStorage.fromChannel || "",
                fromPoint: sessionStorage.fromPoint || "",
            };
            this.$axios
                .post(
                    `${window.API.route.routeOrder}?token=${sessionStorage.token}`,
                    body
                )
                .then(({ data }) => {
                    if (data.code == 200) {
                        localStorage.promoteStr = "";
                        cb && cb(this, data.data);
                    } else {
                        this.isCostLoading = false;
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.isCostLoading = false;
                });
        },
        validateInput() {
            if (!this.username) {
                this.$toast("请填写订单联系人名称！");
                return false;
            }
            if (this.username.length > 25) {
                this.$toast("订单联系人名称不能超过25个字！");
                return false;
            }
            if (!this.telNumber) {
                this.$toast("请输入手机电话号码！");
                return false;
            }
            if (!UTILS.isValidTelNumber(this.telNumber)) {
                this.$toast("手机号格式输入有误！");
                return false;
            }
            return true;
        },
        openModal() {
            this.$refs.modal.openModal();
        },
        closeModal() {
            this.$refs.modal.closeModal();
        },
        receiveDate(date) {
            this.selectedDate = date;
            this.showPageGuide = true;
        },
        openPriceModal() {
            if (this.switchs) {
                this.$refs.pricemodal.closeModal();
                this.switchs = false;
            } else {
                this.$refs.pricemodal.openModal();
                this.switchs = true;
            }
        },
        closeSwitch() {
            this.switchs = false;
        },
    },
};
</script>
<style scoped lang="scss">
.car-order-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    margin-bottom: 1.333333rem;
    .car-order-center {
        flex: auto;
        padding-bottom: 7.333333rem;
    }
    .cell-group {
        margin: 0.32rem 0.373333rem 0 0.373333rem;
        padding: 0 0.4rem;
        background: $white;
        margin-bottom: 0.213333rem;
        box-shadow: 0px 2px 8px 0px rgba(174, 174, 174, 0.25);
        border-radius: 0.266667rem;
        &:last-child {
            margin-bottom: 0px;
        }
        &.form {
            .each-cell {
                // &:first-child {
                //     border-bottom: 0;
                //     padding-bottom: 0px;
                // }
                .label {
                    width: 25%;
                    &.title {
                        width: 100%;
                        font-weight: 600;
                    }
                }
                .content {
                    width: 75%;
                    .van-cell {
                        padding: 0px;
                    }
                }
            }
        }
        &.hotel-preview {
            .each-cell {
                justify-content: flex-start;
                align-items: flex-start;
                &:nth-child(3) {
                    justify-content: space-between;
                }
            }
            .limit-wra {
                color: #8c8c8c;
                font-size: 14px;
                display: flex;
                align-items: center;
                img {
                    width: 0.266667rem;
                    height: 0.266667rem;
                    margin-right: 0.08rem;
                }
            }
        }
        .each-cell {
            padding: 0.266667rem 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &:last-child {
                border-bottom: 0;
            }
            .left-img {
                width: 1.813333rem;
                height: 1.813333rem;
                border-radius: 10px;
                margin-right: 0.266667rem;
            }
            .right-flex {
                width: 100%;
                display: flex;
                justify-content: space-between;
                .title {
                    font-size: 15px;
                    color: #333;
                    font-weight: bold;
                    margin-bottom: 0.266667rem;
                    margin-top: 0.106667rem;
                }
                .type-intro {
                    color: #8c8c8c;
                    font-size: 14px;
                    margin-top: 0.2rem;
                    img {
                        width: 0.16rem;
                        margin-left: 0.16rem;
                        height: 0.266667rem;
                    }
                }
            }
            .grey {
                font-size: 14px;
                color: #999;
            }
            .black {
                font-size: 14px;
                color: #333;
                word-break: break-all;
                width: 6.866667rem;
                // margin-right: 0.466667rem;
            }
            .t {
                font-size: 15px;
                color: #333;
            }
            .r {
                color: #333333;
                flex: 1 0 auto;
                font-size: 15px;
                margin-left: 1.066667rem;

                display: flex;
                justify-content: space-between;
                align-items: center;
                span {
                    font-weight: bold;
                }
                .down-arrow {
                    width: 0.36rem;
                    height: 0.2rem;
                }
            }
            .label {
                font-size: 15px;
                color: $black;
                // width: 30%;
                display: flex;
                flex-direction: column;
                &.title {
                    font-weight: bold;
                    flex-direction: row;
                    align-content: center;
                    .type-intro {
                        color: $light-green;
                        font-size: 12px;
                        margin-top: 0px;
                        margin-left: 0.373333rem;
                        margin-top: 0.026667rem;
                        img {
                            width: 0.16rem;
                            margin-left: 0.16rem;
                            height: 0.266667rem;
                        }
                    }
                }
                .title {
                    .sub {
                        padding-left: 0.2rem;
                        font-size: 12px;
                        color: #b3b3b3;
                    }
                }
            }
            // .content-specail{
            //     flex-direction: column;
            // }
            .content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .price-wra {
                    margin-right: 0.4rem;
                    &.deposit {
                        margin-right: 0.1rem;
                        span {
                            font-weight: normal;
                        }
                    }
                    .suffix {
                        font-size: 0.373333rem;
                        color: #ff6a62;
                        font-weight: bold;
                    }
                    .price {
                        font-size: 0.533333rem;
                        color: #ff6a62;
                        font-weight: bold;
                    }
                }

                .select-date {
                    font-size: 14px;
                    color: #999999;
                    .se-img {
                        width: 0.16rem;
                        height: 0.266667rem;
                        margin-left: 0.16rem;
                    }
                }
                .selected-date {
                    font-size: 14px;
                    color: #999999;
                    .se-img {
                        width: 0.16rem;
                        height: 0.266667rem;
                        margin-left: 0.16rem;
                    }
                }

                .deposit-info {
                    color: $grey4;
                    font-size: 13px;
                }
            }
        }
        .each-cell-specail {
            width: 100%;
            justify-content: space-between !important;
            padding: 0;
            align-items: center !important;
            .suffix {
                font-size: 0.373333rem;
                color: #ff6a62;
                font-weight: bold;
            }
            .price {
                font-size: 0.533333rem;
                color: #ff6a62;
                font-weight: bold;
            }
        }
    }
    .submit-wrapper {
        position: fixed;
        bottom: 0;
        padding-left: 0.466667rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 1.333333rem;
        box-shadow: -1px -4px 20px 0px rgba(0, 0, 0, 0.05);
        background: $white;
        flex: none;
        z-index: 10002;
        .total {
            display: flex;
            padding-right: 0.4rem;
            align-items: center;
            justify-content: space-between;
            width: 3.4rem;
            .zj {
                display: flex;
                flex-direction: column;
            }
            .text {
                color: #666666;
                font-size: 12px;
            }
            .price-wra {
                .suffix {
                    font-size: 18px;
                    color: #ff6a62;
                    font-weight: bold;
                }
                .price {
                    font-size: 0.693333rem;
                    font-family: PingFangSC-Semibold;
                    font-weight: 600;
                    color: #ff6a62;
                    line-height: 0.986667rem;
                }
            }
            .detail {
                font-size: 0.32rem;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #f8b356;
                display: flex;
                align-items: center;
                img {
                    margin-left: 0.173333rem;
                    width: 0.16rem;
                    height: 0.266667rem;
                    transform: rotate(90deg);
                    transition: 0.3s;
                    &.active {
                        transform: rotate(270deg);
                    }
                }
            }
        }
        .confirm-btn {
            width: 4.8rem;
            height: 1.066667rem;
            background: linear-gradient(
                90deg,
                rgba(248, 199, 64, 1) 0%,
                rgba(245, 149, 38, 1) 100%
            );
            border-radius: 0.533333rem;
            margin-right: 0.533333rem;
            text-align: center;
            color: $white;
            font-size: 0.426667rem;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            line-height: 1.066667rem;
        }
    }
}
</style>
